import Notification from '@/components/Notification';
import { decryptionData } from '@/components/utils/utils.js';
import axios from "axios";
import { mapGetters } from 'vuex';

export default {
  components: {
    Notification: Notification
  },
  data() {
    return {
      activeTab: 'group-analysis',

      tableLoading: false,
      btnload: false,
      alertSuccess: '',
      alertFailed: '',
      alert_err_attention: '',

      brnadCategoryRole: [
        v => !!v || 'Brand Category Name is required',
        v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'Input may contain letters, numbers, spaces, and special characters (.@_-)',
      ],
      analysisGroupRole: [
        v => !!v || 'Group Analysis Name is required',
        v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'Input may contain letters, numbers, spaces, and special characters (.@_-)',
      ],

      id_seq: '',
      brnadCategory: '',
      analysisGroup: '',
      image_url: '',
      file: '',
      previewImage: '',
      statusactive: 1,
      itemsactivate: [
        { valueactive: 1, name_active: "Active" },
        { valueactive: 0, name_active: "Disable" }
      ],

      dialog: false,
      dialogDelete: false,
      search: '',
      analysisHeaders: [
        { text: 'Analysis Group', value: 'GROUP_ANALYSIS' },
        { text: 'Status', value: 'STATUS_TEXT' },
        { text: 'Created Date', value: 'SYS_CREATED_DATE' },
        { text: 'Created By', value: 'USERNAME_CREATE' },
        { text: 'Update Date', value: 'SYS_UPDATED_DATE' },
        { text: 'Update By', value: 'USERNAME_UPDATE' },
        { text: 'Image', value: 'image' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      brandHeaders: [
        { text: 'Name Brand Category', value: 'NAME_CATEGORY' },
        { text: 'Status', value: 'STATUS_TEXT' },
        { text: 'Created Date', value: 'SYS_CREATED_DATE' },
        { text: 'Created By', value: 'USERNAME_CREATE' },
        { text: 'Update Date', value: 'SYS_UPDATED_DATE' },
        { text: 'Update By', value: 'USERNAME_UPDATE' },
        { text: 'Image', value: 'image' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      dataTable: [],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
    }
  },
  computed: {
    page() {
      return this.$store.state.breadcrumbs
    },
    ...mapGetters(['navbarWithName']),
    formTitle() {
      const prefix = this.activeTab === 'group-analysis' ? 'Group Analysis' : 'Brand Category'
      return this.editedIndex === -1 ? `Add ${prefix}` : `Update ${prefix}`
    },
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
    dialogDelete(val) {
      val || this.closeDelete()
    },
    activeTab() {
      this.close()
      this.initialize()
    }
  },
  created() {
    this.initialize()
  },
  methods: {
    goBack() {
      this.$router.push('/PinnedAccount')
    },
    getColor(status) {
      return status === 'Disabled' ? 'red' : 'green';
    },
    selectfile(event) {
      this.file = event;
      if (event) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.previewImage = e.target.result;
        };
        reader.readAsDataURL(event);
      }
    },
    onClear() {
      this.previewImage = '';
      this.file = null;
    },
    initialize() {
      this.tableLoading = true;
      const url = this.activeTab === 'group-analysis' ? 'analysis_group' : 'brand_category'
      axios.get(url,
        { headers: { 'auth-token': localStorage.getItem('token_app') } },
        { dataType: 'json' }
      ).then((response) => {
        this.dataTable = decryptionData(response.data.token);
        setTimeout(() => {
          this.loading = false
        }, 1000)
        this.tableLoading = false;
      }).catch((e) => {
        switch (e.response.status) {
          case 404:
            this.$refs.alert.error_login(404);
            break;
          case 403:
            this.$refs.alert.error_login(403);
            break;
          default:
            console.log('some other error');
            break;
        }
        this.errors = e.response.data.msg;
      });
    },
    deleteItem(item) {
      this.id_seq = item
      this.editedIndex = this.dataTable.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDelete = true
    },
    deleteItemConfirm() {
      this.dataTable.splice(this.editedIndex, 1)
      axios({
        method: "delete",
        url: "analysis_group/delete",
        data: {
          seq_id: this.id_seq
        },
        headers: { 'auth-token': localStorage.getItem('token_app') },
        dataType: 'json'
      }).then((response) => {
        var status = response.data.status
        var messages = response.data.msg
        if (status == 200) {
          this.initialize();
          this.alertSuccess = true;
          this.alert_err_attention = messages;
          this.closeDelete()
        } else {
          this.alertFailed = true;
          this.alert_err_attention = messages;
        }
      }).catch(function (error) {
        this.alertFailed = true;
        this.alert_err_attention = 'Delete Failed ' + error;
      })
      this.closeDelete()
    },
    closeDelete() {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    editItem(item) {
      this.editedIndex = this.dataTable.indexOf(item)
      this.dialog = true
      this.id_seq = item.SEQ_ID
      if (this.activeTab === 'group-analysis') {
        this.analysisGroup = item.GROUP_ANALYSIS
      } else {
        this.brnadCategory = item.NAME_CATEGORY
      }
      this.statusactive = item.STATUS
      if (item.PRS_IMAGE) {
        this.previewImage = item.PRS_IMAGE
      } else {
        this.previewImage = ''
      }
      this.file = null
    },
    async save() {
      const isValid = this.$refs.form.validate();
      const formData = new FormData();
      formData.append('image', this.file);
      formData.append('seq_id', this.id_seq);

      const isAnalysis = this.activeTab === 'group-analysis'
      const fieldName = isAnalysis ? 'analysis_group' : 'brand_category'
      const fieldValue = isAnalysis ? this.analysisGroup : this.brnadCategory
      const url = isAnalysis ? 'analysis_group' : 'brand_category'

      formData.append(fieldName, fieldValue);
      formData.append('status', this.statusactive);

      if (this.editedIndex > -1) {
        if (isValid) {
          this.btnload = true
          await axios.put(`${url}/update`, formData,
            {
              headers: {
                'auth-token': localStorage.getItem('token_app'),
                'Content-Type': 'multipart/form-data',
              }
            },
            { dataType: 'json' },
          ).then((response) => {
            var status = response.data.status
            var messages = response.data.msg
            if (status == 200) {
              this.initialize();
              this.alertSuccess = true;
              this.alert_err_attention = messages;
              this.btnload = false
              this.close()
            } else {
              this.alertFailed = true;
              this.alert_err_attention = messages;
              this.btnload = false
            }
          }).catch((e) => {
            switch (e.response.status) {
              case 404:
                this.$refs.alert.error_login(404);
                break;
              case 403:
                this.$refs.alert.error_login(403);
                break;
              case 400:
                this.alertFailed = true;
                this.alert_err_attention = e.response.data.msg;
                break;
              default:
                console.log('some other error');
                break;
            }
            this.errors = e.response.data.msg;
          });
        }
      } else {
        if (isValid) {
          this.btnload = true
          await axios.post(`${url}/insert`, formData,
            {
              headers: {
                'auth-token': localStorage.getItem('token_app'),
                'Content-Type': 'multipart/form-data',
              }
            },
            { dataType: 'json' },
          ).then((response) => {
            var status = response.data.status
            var messages = response.data.msg
            if (status == 200) {
              this.initialize();
              this.alertSuccess = true;
              this.alert_err_attention = messages;
              this.btnload = false
              this.close()
            } else {
              this.alertFailed = true;
              this.alert_err_attention = messages;
              this.btnload = false
            }
          }).catch((e) => {
            switch (e.response.status) {
              case 404:
                this.$refs.alert.error_login(404);
                break;
              case 403:
                this.$refs.alert.error_login(403);
                break;
              case 400:
                this.alertFailed = true;
                this.alert_err_attention = e.response.data.msg;
                break;
              default:
                console.log('some other error');
                break;
            }
            this.errors = e.response.data.msg;
          });
          this.close()
        }
      }
    },
    close() {
      this.file = '';
      this.image_url = '';
      this.brnadCategory = '';
      this.analysisGroup = '';
      this.onClear()
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
  },
}
